import { useState } from "react";
import { useCategories } from "@/contexts/CategoriesContext";
import { AddCategoryDialog } from "@/components/categories/AddCategoryDialog";

const ADD = "__add_category__";

/** Category dropdown with a built-in "+ Add new category…" option.

    onChange receives the category NAME (a string), not an event. */
export function CategorySelect({ type = "expense", value, onChange, testid, className }) {
  const lists = useCategories();
  const [showDialog, setShowDialog] = useState(false);
  const cats = lists[type] || lists.expense;
  // Keep legacy/renamed values visible instead of silently snapping to another category
  const options = value && !cats.includes(value) ? [value, ...cats] : cats;

  const handle = (e) => {
    if (e.target.value === ADD) {
      setShowDialog(true);
      return; // keep current value until the dialog saves
    }
    onChange(e.target.value);
  };

  return (
    <>
      <select
        value={value}
        onChange={handle}
        data-testid={testid}
        className={className || "w-full bg-transparent border-b border-[#1A1F16] py-2 focus:outline-none"}
      >
        {options.map((c) => <option key={c} value={c}>{c}</option>)}
        <option value={ADD}>＋ Add new category…</option>
      </select>
      {showDialog && (
        <AddCategoryDialog
          defaultKind={type}
          onClose={() => setShowDialog(false)}
          onSaved={(name) => onChange(name)}
        />
      )}
    </>
  );
}
